module.exports = __webpack_public_path__ + "img/partner_layout1.069c6135.png";